// extracted by mini-css-extract-plugin
export default {"profileDetails":"PersonalDetails_profileDetails__lIh1+","personalDetails":"PersonalDetails_personalDetails__h2cR1"};